require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/es7.symbol.observable.js
// module id = 464
// module chunks = 0